import axios from "axios";
import { loadProgressBar } from "axios-progress-bar";
import "axios-progress-bar/dist/nprogress.css";
import qs from "qs";
import { useEffect } from "react";
import useErrorHandler from "../hooks/api/useErrorHandler";
import useAuth from "../hooks/auth";

const AxiosProvider = () => {
  const { authHeaders } = useAuth();
  const errorHandler = useErrorHandler();

  useEffect(() => {
    const interceptor = axios.interceptors.request.use((config) => {
      Object.assign(config.headers, {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...authHeaders,
      });

      config.paramsSerializer = (params) => {
        return qs.stringify(params, {
          arrayFormat: "brackets",
          encode: false,
        });
      };

      return config;
    });

    return () => axios.interceptors.request.eject(interceptor);
  }, [authHeaders]);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => Promise.reject(errorHandler(error))
    );

    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  useEffect(() => {
    loadProgressBar({ showSpinner: false });
  }, []);

  return null;
};

export default AxiosProvider;
